import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";
const axiosInstance = axios.create({ baseURL: API, withCredentials: true });
// Fetch list of available staff/users for Owner
export const getAvailableUsers = async () => {
  const response = await axiosInstance.get("/chat/users");
  return response.data;
};
// Create a direct or group conversation
export const createConversation = async (data) => {
  const response = await axiosInstance.post("/chat/conversations/create", data);
  return response.data;
};

// Fetch all active conversations for the current user
export const getAllConversations = async () => {
  const response = await axiosInstance.get("/chat/conversations/all");
  return response.data;
};

// Fetch paginated messages for a given conversation
export const getConversationMessages = async (conversationId, page = 1, limit = 50) => {
  const queryParams = new URLSearchParams({ page, limit });
  const response = await axiosInstance.get(
    `/chat/conversations/${conversationId}/messages?${queryParams.toString()}`
  );
  return response.data;
};

// Add member to group conversation
export const addGroupMember = async (conversationId, memberData) => {
  const response = await axiosInstance.post(
    `/chat/conversations/${conversationId}/members`,
    memberData
  );
  return response.data;
};

// Remove member from group conversation
export const removeGroupMember = async (conversationId, userId) => {
  const response = await axiosInstance.delete(
    `/chat/conversations/${conversationId}/members/${userId}`
  );
  return response.data;
};

// Update group metadata (name, description, groupIcon)
export const updateConversation = async (conversationId, data) => {
  const response = await axiosInstance.put(
    `/chat/conversations/${conversationId}`,
    data
  );
  return response.data;
};

// Soft delete message
export const deleteMessage = async (messageId) => {
  const response = await axiosInstance.delete(`/chat/messages/${messageId}`);
  return response.data;
};

// Upload attachment (image or document) to Cloudinary
export const uploadChatFile = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await axiosInstance.post("/chat/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};